module.exports = __webpack_public_path__ + "0.ef42161570719d7ee8d9.worker.js"